import axios from 'axios';
import { auth } from '../config/firebase';

// En producción usamos rutas relativas, en desarrollo usamos localhost
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // URL relativa en producción
  : 'http://localhost:3400/api';  // URL completa en desarrollo

// Crear y exportar la instancia de axios para llamadas normales
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para usuarios normales
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const scratchService = {
  startParticipation: async (campaignId) => {
    try {
      const response = await api.post('/scratch/start', {
        campaignId,
        userId: auth.currentUser.uid
      });
      return response.data;
    } catch (error) {
      console.error('Error en startParticipation:', error.response?.data || error);
      throw error;
    }
  },

  completeParticipation: async (participationId) => {
    const response = await api.put(`/scratch/complete/${participationId}`);
    return response.data;
  },

  getUserParticipations: async () => {
    const response = await api.get(`/scratch/user/${auth.currentUser.uid}`);
    return response.data;
  },

  getMyPrizes: async () => {
    try {
      const response = await api.get('/scratch/my-prizes');
      return response.data;
    } catch (error) {
      console.error('Error al obtener premios:', error);
      throw error;
    }
  }
};

export const campaignService = {
  getActiveCampaigns: async () => {
    try {
      const response = await api.get('/campaigns/active');
      return response.data;
    } catch (error) {
      console.error('Error getting active campaigns:', error);
      return { success: false, error: error.message };
    }
  },

  getCampaign: async (id) => {
    const response = await api.get(`/campaigns/${id}`);
    return response.data;
  },

  getCampaignBySlug: async (slug) => {
    const response = await api.get(`/campaigns/slug/${slug}`);
    return response.data;
  },

  getFinishedCampaigns: async () => {
    try {
      const response = await api.get('/campaigns/finished');
      return response.data;
    } catch (error) {
      console.error('Error getting finished campaigns:', error);
      return { success: false, error: error.message };
    }
  }
};

export const userService = {
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  getUser: async (firebaseId) => {
    const response = await api.get(`/users/${firebaseId}`);
    return response.data;
  },

  updateUserProfile: async (userData) => {
    try {
      const response = await api.put('/users/profile', userData);
      return response.data;
    } catch (error) {
      console.error('Error actualizando perfil:', error);
      throw error;
    }
  },

  updateUserConsents: async (consents) => {
    try {
      const response = await api.put('/users/consents', { consents });
      return response.data;
    } catch (error) {
      console.error('Error actualizando consentimientos:', error);
      throw error;
    }
  }
};

export const apiUpload = {
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`${API_URL}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
}; 